import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=05eb8954&scoped=true"
import script from "./EditDialog.vue?vue&type=script&lang=js"
export * from "./EditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eb8954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05eb8954')) {
      api.createRecord('05eb8954', component.options)
    } else {
      api.reload('05eb8954', component.options)
    }
    module.hot.accept("./EditDialog.vue?vue&type=template&id=05eb8954&scoped=true", function () {
      api.rerender('05eb8954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/EditDialog.vue"
export default component.exports